import i18n from "config/i18next";

i18n.addResources("es", "vehicle", {
  patentLabel: "Placa del vehículo *",
  patentPlaceholder: "Ingresá los dígitos de la placa",
  licenseExpirationLabel: "Licencia de conducir *",
  carInsuranceExpirationLabel: "SOAT *",
  patentLongError: "La placa debe tener entre 6 y 7 caracteres",
  patentFormatError: "La placa ingresada es inválida",
  typeLabel: "Vehículo *",
});

i18n.addResources("es_AR", "vehicle", {
  patentLabel: "Patente del vehículo *",
  patentPlaceholder: "Ingresá los dígitos de la patente",
  identifierExpirationLabel: "Cédula de conducir *",
  carInsuranceExpirationLabel: "Seguro de automotor *",
  patentLongError: "La patente debe tener entre 6 y 7 caracteres",
  wheels4PatentLongError: "La patente debe tener entre 6 y 7 caracteres",
  patentFormatError: "La patente ingresada es inválida",
});

i18n.addResources("es_CO", "vehicle", {
  wheels4PatentLongError: "La placa debe tener 6 caracteres",
});

i18n.addResources("es_MX", "vehicle", {
  identifierExpirationLabel: "Tarjeta de circulación vigente *",
  carInsuranceExpirationLabel: "Póliza de seguro vial *",
  wheels4PatentLongError: "La patente debe tener entre 6 y 7 caracteres",
  patentLongError: "La placa debe tener entre 5 y 7 caracteres",
});

i18n.addResources("es_CL", "vehicle", {
  patentLabel: "Placa del vehículo *",
  patentPlaceholder: "Ingresá la placa del vehículo",
  identifierExpirationLabel: "Permiso de circulación *",
  carInsuranceExpirationLabel: "Seguro (SOAP) *",
  patentLongError: "La placa debe tener 5 caracteres",
  wheels4PatentLongError: "La placa debe tener 6 caracteres",
});
